// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { Trans as T, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import hopt from 'hola_opt';
import zutil from '/util/util.js';
import { img_url } from '../ui/img_url';
import { Link } from '../ui/link';
import www_util from '../util.js';
import { App_context } from '../context.js';
import { ga_track_download_send } from '../ga';
import { get_link } from '../install_links.js';
import { show_download_link } from '../ui/is_app_visible';
import { guess_os_and_version } from '../client_hints_global';
var img_icons = {
  browser: 'ic_browser',
  adblock: 'ic_adblocker',
  gps: 'ic_gps',
  luminati: 'ic_brightdata',
  viddly: 'ic_viddly',
  shoopit: 'ic_shoopit'
};
var Download_link = props => {
  useTranslation();
  var item = props.item,
    on_click = props.on_click,
    source = props.source,
    tag = props.tag,
    render_marker = props.render_marker,
    cls = props.cls,
    _props$icons = props.icons,
    icons = _props$icons === void 0 ? {} : _props$icons;
  var _useContext = useContext(App_context),
    has_svc = _useContext.has_svc,
    svc_info = _useContext.svc_info;
  var name = item.name,
    title = item.title,
    label = item.label;
  var link = get_link({
    has_svc,
    svc_info,
    item
  });
  var opts = !link.startsWith('/') && {
    target: '_blank',
    rel: 'noreferrer noopener'
  };
  var conf = zutil.get(hopt, `www_hola.hola_apps.${name}`);
  var history = useHistory();
  var handle_click = ev => {
    if (conf && conf.track) www_util.perr({
      id: `www_${name}_${source}_link_click`
    });
    if (name == 'windows' || name == 'mac' || name == 'mac_beta') {
      ga_track_download_send(name == 'windows' ? 'exe' : 'dmg', 'products', link, null, undefined, {});
      // download_file(link);
      history.push(location.pathname + '?flow=full&step=install&os=' + (name == 'windows' ? 'windows' : 'macos'));
    }
    on_click && on_click(ev);
  };
  var sys = guess_os_and_version();
  var show = show_download_link(name, {
    source,
    sys,
    has_svc
  });
  var Tag = tag || 'li';
  var icon = icons[name] || /*#__PURE__*/React.createElement("img", {
    width: 32,
    height: 32,
    alt: "platforms",
    src: img_url(`/platforms/${img_icons[name]}.svg`),
    className: "lazyload"
  });
  return show ? /*#__PURE__*/React.createElement(Tag, {
    className: cls
  }, /*#__PURE__*/React.createElement(Link, _extends({
    to: link,
    onClick: handle_click
  }, opts), icon, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, null, title)), label && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, null, label)), render_marker && render_marker({
    width: 12,
    height: 12,
    top: 8,
    right: 8
  }))) : null;
};
export { Download_link, show_download_link };